// utils/permissions.js
export default function can(permissions: string | string[]): boolean {
  const authStore = useAuthStore();

  if (Array.isArray(permissions)) {
    return permissions.some((permission) => {
      return authStore.auth?.permissions?.includes(permission);
    });
  } else {
    return authStore.auth?.permissions?.includes(permissions);
  }
}
